import { render, staticRenderFns } from "./SectionFeatures.vue?vue&type=template&id=86929e52&scoped=true&"
import script from "./SectionFeatures.vue?vue&type=script&lang=ts&"
export * from "./SectionFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./SectionFeatures.vue?vue&type=style&index=0&id=86929e52&lang=scss&scoped=true&"
import style1 from "./SectionFeatures.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "86929e52",
  null
  
)

export default component.exports